import { EventEmitter } from "@angular/core";
import { environment } from '../../../../environments/environment';
import { TranslateService } from "@ngx-translate/core";
import { CustomerService } from "../../services/customer.service";
import { FileUploadConstants } from "../../constants/file-upload.constants";
import { ReportService } from "../../services/report.service";
import { CommonService } from "../../../shared/services/common.service";
import { NotificationType } from "../../enums/notification-types.enum";
import { DeliveryPreference, MemberLevel, OrderTypeTitle, } from '../../common/enumerations';
import { OrderTypeValues, DelivaryOptionType } from '../../common/constants';
import { MemberTypeEnum } from "../../enums/member-type.enum";
import { StatusConstants } from "../../constants/status.constants";
import { DatePipe } from "@angular/common";
import { DateConstants } from "../../constants/date.constants";
import { DistributorIdFormatPipe } from "../../../common/pipes/distributor-id-format.pipe";
import { CurrencyTransformPipe } from "../../../common/pipes/currency-format.pipe";
import { ResponseStatus } from "../../constants/response-status-constants";
var OrderReportsComponent = /** @class */ (function () {
    function OrderReportsComponent(_translateService, _customerservice, _reportService, _commonService, _datePipe, distributorFormatPipe, _currencyPipe) {
        this._translateService = _translateService;
        this._customerservice = _customerservice;
        this._reportService = _reportService;
        this._commonService = _commonService;
        this._datePipe = _datePipe;
        this.distributorFormatPipe = distributorFormatPipe;
        this._currencyPipe = _currencyPipe;
        this.isLoadedData = new EventEmitter();
        this.addFavoriteEvent = new EventEmitter();
        this.pageSizes = [50, 100, 150, 200];
        this.pageNumber = 1;
        this.pageSize = 50;
        this.pageCount = 0;
        this.currentDate = new Date();
        this.excelIconUrl = environment.cdnURL + '/flpi/images/ms_excel.ico';
        this.printIconUrl = environment.cdnURL + '/flpi/images/print_icon.png';
        this.ordersReport = null;
        this.allOrdersReport = null;
        this.isResponseError = false;
        this.isLoading = false;
        this.isAllOrdersReportLoading = false;
        this.isShowReport = true;
        this.csvType = FileUploadConstants.CSV_FILE_EXTENSION;
        this.printType = FileUploadConstants.PRINT;
        this.pollCount = 0;
        this.maxPollCount = 15;
    }
    OrderReportsComponent.prototype.ngOnInit = function () {
        // this.getOrdersReport();
        this.exportFile('csv');
    };
    /**
     * To get orders report
     * @returns void
     */
    OrderReportsComponent.prototype.getOrdersReport = function () {
        this.isLoading = true;
        this.getOrdersReportWithPolling(this._reportService.getConstructedOrderReportUrl(this.storeId, this.fromDate, this.toDate, this.pageNumber, this.pageSize, false));
    };
    OrderReportsComponent.prototype.getOrdersReportWithPolling = function (url) {
        var _this = this;
        this._reportService.getOrderPollReport(url).subscribe(function (response) {
            if (response.status === ResponseStatus.COMPLETED) {
                _this.pollCount = 0;
                _this.ordersReport = response.responseModel ? response.responseModel.content : null;
                _this.isLoading = false;
                _this.isResponseError = false;
                _this.pageCount = response.responseModel ? response.responseModel.totalCount : null;
                _this.isLoadedData.emit(true);
            }
            else if (response && response.status && response.status.code === 504) {
                var message = _this._translateService.get('reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again');
                _this._commonService.createNotification('', message.value, NotificationType.ERROR);
                _this.setDefaultValues();
            }
            else {
                if ((response.status === ResponseStatus.IN_PROGRESS) || (response.status === ResponseStatus.QUEUED)) {
                    if (_this.pollCount < _this.maxPollCount) {
                        _this.pollCount = _this.pollCount + 1;
                        _this.getOrdersReportWithPolling(response.location);
                    }
                    else {
                        var message = _this._translateService.get('reports.Something Went Wrong, Please try again after some time');
                        _this._commonService.createNotification('', message.value, NotificationType.ERROR);
                        _this.setDefaultValues();
                    }
                }
            }
        }, function (error) {
            if (error.status == 504 || (error.name && error.name.toLowerCase() == 'typeerror')) {
                var message = _this._translateService.get('reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again');
                _this._commonService.createNotification('', message.value, NotificationType.ERROR);
                _this.setDefaultValues();
            }
            else {
                var message = _this._translateService.get('reports.Something Went Wrong, Please try again after some time');
                _this._commonService.createNotification('', message.value, NotificationType.ERROR);
                _this.setDefaultValues();
            }
        });
    };
    /**
     * To Set Default Values
     */
    OrderReportsComponent.prototype.setDefaultValues = function () {
        this.ordersReport = null;
        this.isLoading = false;
        this.isResponseError = true;
        this.pageCount = 0;
        this.isLoadedData.emit(true);
    };
    /**
     * To load orders report
     * @returns void
     */
    OrderReportsComponent.prototype.loadOrdersReports = function () {
        this.isShowReport = true;
        this.getOrdersReport();
    };
    /**
    * To change page size
    * @param  {number} pageSize
    * @returns void
    */
    OrderReportsComponent.prototype.pageSizeChange = function (pageSize) {
        if (pageSize) {
            this.pageNumber = 1;
            this.pageSize = pageSize;
            this.getOrdersReport();
        }
    };
    /**
     * To change page number
     * @param  {number} pageNumber
     */
    OrderReportsComponent.prototype.pageChange = function (pageNumber) {
        this.pageNumber = pageNumber;
        this.getOrdersReport();
    };
    /**
     * To emit add favorite event to parent component
     * @returns void
     */
    OrderReportsComponent.prototype.addToFavorite = function () {
        this.addFavoriteEvent.emit(true);
    };
    /**
     * To Export The file
     */
    OrderReportsComponent.prototype.exportFile = function (type) {
        // if (this.allOrdersReport && this.allOrdersReport.length > 0) {
        //     this.download(type);
        // } else {
        //     this.fetchAllOrdersReport(type);
        // }
        this.fetchAllOrdersReport(type);
    };
    /**
     * To Fetch all orders report data from service
     */
    OrderReportsComponent.prototype.fetchAllOrdersReport = function (type) {
        this.isLoading = true;
        this.isAllOrdersReportLoading = true;
        this.getOrdersReportToExportFile(this._reportService.getConstructedOrderReportUrl(this.storeId, this.fromDate, this.toDate, this.pageNumber, this.pageSize, true), type);
    };
    OrderReportsComponent.prototype.getOrdersReportToExportFile = function (url, type) {
        var _this = this;
        this._reportService.getOrderPollReport(url).subscribe(function (response) {
            if (response.status === ResponseStatus.COMPLETED) {
                _this.pollCount = 0;
                _this.isAllOrdersReportLoading = false;
                _this.isLoading = false;
                _this.isResponseError = false;
                _this.ordersReport = response.responseModel ? response.responseModel.content : null;
                _this.allOrdersReport = response.responseModel ? response.responseModel.content : null;
                _this.isLoadedData.emit(true);
                _this.download(type);
            }
            else {
                if ((response.status === ResponseStatus.IN_PROGRESS) || (response.status === ResponseStatus.QUEUED)) {
                    if (_this.pollCount < _this.maxPollCount) {
                        _this.pollCount = _this.pollCount + 1;
                        _this.getOrdersReportToExportFile(response.location, type);
                    }
                    else {
                        _this.isAllOrdersReportLoading = false;
                        _this.allOrdersReport = null;
                        var message = _this._translateService.get('reports.Something Went Wrong, Please try again after some time');
                        _this._commonService.createNotification('', message.value, NotificationType.ERROR);
                        _this.setDefaultValues();
                    }
                }
            }
        }, function (error) {
            var message = _this._translateService.get('reports.Something Went Wrong, Please try again after some time');
            _this._commonService.createNotification('', message.value, NotificationType.ERROR);
            _this.allOrdersReport = null;
            _this.isAllOrdersReportLoading = false;
        });
    };
    /**
     * To download CSV or Print file from response data
     * @param  {string} type
     * @returns void
     */
    OrderReportsComponent.prototype.download = function (type) {
        var allOrdersReportLength = this.allOrdersReport && this.allOrdersReport.length ?
            this.allOrdersReport && this.allOrdersReport.length : null;
        if (allOrdersReportLength > 0) {
            var columns = [
                this._translateService.get('reports.Item Numbers')['value'],
                this._translateService.get('reports.Revision Number')['value'],
                this._translateService.get('reports.Web Order Id')['value'],
                this._translateService.get('reports.Order Number')['value'],
                this._translateService.get('reports.Payment Mode')['value'],
                this._translateService.get('reports.Payment Status')['value'],
                this._translateService.get('reports.Card Type')['value'],
                this._translateService.get('reports.Member Level')['value'],
                this._translateService.get('reports.Order Type')['value'],
                this._translateService.get('reports.Order Created Date')['value'],
                this._translateService.get('reports.Order Posted Date')['value'],
                this._translateService.get('reports.Payment Date')['value'],
                this._translateService.get('reports.Distributor ID')['value'],
                this._translateService.get('reports.Member Type')['value'],
                this._translateService.get('reports.Order Status')['value'],
                this._translateService.get('reports.AS400 Acknowledgement')['value'],
                this._translateService.get('reports.AS400 Error')['value'],
                this._translateService.get('reports.FD Status')['value'],
                this._translateService.get('reports.FD Fulfillment Number')['value'],
                this._translateService.get('reports.FD Error')['value'],
                this._translateService.get('reports.Order Total')['value'],
                this._translateService.get('reports.Source')['value'],
                this._translateService.get('reports.Shipping Method Display Name')['value'],
                this._translateService.get('reports.Payment Amount')['value'],
                this._translateService.get('reports.Order CC')['value'],
                this._translateService.get('reports.Delivery Method')['value'],
                this._translateService.get('reports.Warehouse Name')['value'],
                this._translateService.get('reports.Payment Error')['value'],
                this._translateService.get('reports.Payment Processor Transaction Number')['value'],
            ];
            var title = this._translateService.get('reports.Orders Report')['value'] + "_" + this.fromDate + this._translateService.get('reports._To_')['value'] + this.toDate;
            if (type === this.csvType) {
                this.downloadCSV(columns, allOrdersReportLength);
            }
            else if (type === this.printType) {
                this.printReportDetails(title, columns, allOrdersReportLength);
            }
        }
    };
    /**
    * To get the member level for  order report details
    */
    OrderReportsComponent.prototype.getMemberLevel = function (memberLevel) {
        if (memberLevel === MemberLevel.RETAIL) {
            memberLevel = StatusConstants.Retail;
        }
        if (memberLevel === MemberLevel.PREFERREDCUSTOMER) {
            memberLevel = StatusConstants.PreferredCustomer;
        }
        if (memberLevel === MemberLevel.ASSISTANTSUPERVISOR) {
            memberLevel = StatusConstants.Assistant_Supervisor;
        }
        if (memberLevel === MemberLevel.SUPERVISOR) {
            memberLevel = StatusConstants.Supervisor;
        }
        if (memberLevel === MemberLevel.ASSISTANTMANAGER) {
            memberLevel = StatusConstants.Assistant_Manager;
        }
        if (memberLevel === MemberLevel.MANAGER) {
            memberLevel = StatusConstants.Manager;
        }
        if (memberLevel === MemberLevel.UNRECOGNIZEDMANAGER) {
            memberLevel = StatusConstants.Unrecognized_Manager;
        }
        if (memberLevel === MemberLevel.RECOGNIZEDMANAGER) {
            memberLevel = StatusConstants.Recognized_Manager;
        }
        if (memberLevel === MemberLevel.SENIORMANAGER) {
            memberLevel = StatusConstants.Senior_Manager;
        }
        if (memberLevel === MemberLevel.SOARINGMANAGER) {
            memberLevel = StatusConstants.Soaring_Manager;
        }
        if (memberLevel === MemberLevel.SAPPHIREMANAGER) {
            memberLevel = StatusConstants.Sapphire_Manager;
        }
        if (memberLevel === MemberLevel.DIAMONDSAPPHIREMANAGER) {
            memberLevel = StatusConstants.Diamond_Sapphire_Manager;
        }
        if (memberLevel === MemberLevel.DIAMONDMANAGER) {
            memberLevel = StatusConstants.Diamond_Manager;
        }
        if (memberLevel === MemberLevel.DOUBLEDIAMONDMANAGER) {
            memberLevel = StatusConstants.Double_Diamond_Manager;
        }
        if (memberLevel === MemberLevel.TRIPLEDIAMONDMANAGER) {
            memberLevel = StatusConstants.Triple_Diamond_Manager;
        }
        if (memberLevel === MemberLevel.DIAMONDCENTURIONMANAGER) {
            memberLevel = StatusConstants.Diamond_Centurion_Manager;
        }
        if (memberLevel === MemberLevel.GUEST) {
            memberLevel = StatusConstants.GUEST;
        }
        if (memberLevel === MemberLevel.NOVICCUSTOMER) {
            memberLevel = StatusConstants.Novus;
        }
        return memberLevel;
    };
    /**
    * To get the order type for order report details
    */
    OrderReportsComponent.prototype.getOrderType = function (orderType) {
        if (orderType === OrderTypeTitle.ENROLLMENT) {
            orderType = OrderTypeValues.ENROLLMENT;
        }
        if (orderType === OrderTypeTitle.PERSONAL) {
            orderType = OrderTypeValues.PERSONAL;
        }
        if (orderType === OrderTypeTitle.AUTOSHIP) {
            orderType = OrderTypeValues.AUTOSHIP;
        }
        if (orderType === OrderTypeTitle.OFFICE_POS) {
            orderType = OrderTypeValues.OFFICE_POS;
        }
        if (orderType === OrderTypeTitle.EVENT_POS) {
            orderType = OrderTypeValues.EVENT_POS;
        }
        if (orderType === OrderTypeTitle.RETAIL) {
            orderType = OrderTypeValues.RETAIL;
        }
        if (orderType === OrderTypeTitle.AMZUS) {
            orderType = OrderTypeValues.AMZUS;
        }
        if (orderType === OrderTypeTitle.SERVICE) {
            orderType = OrderTypeValues.SERVICE;
        }
        return orderType;
    };
    /**
    * To get the member type for order report details
    */
    OrderReportsComponent.prototype.getMemberType = function (memberType) {
        if (memberType === MemberTypeEnum.DISTRIBUTOR) {
            memberType = StatusConstants.Distributor;
        }
        if (memberType === MemberTypeEnum.RETAIL) {
            memberType = StatusConstants.Retail;
        }
        if (memberType === MemberTypeEnum.GUEST) {
            memberType = StatusConstants.GUEST;
        }
        if (memberType === MemberTypeEnum.FPC) {
            memberType = StatusConstants.Preferred_Customer;
        }
        return memberType;
    };
    /**
    * To get the delivery method for order report details
    */
    OrderReportsComponent.prototype.getDeliveryPreference = function (deliveryMethod) {
        if (deliveryMethod === DeliveryPreference.DELIVERY) {
            deliveryMethod = DelivaryOptionType.Delivery;
        }
        if (deliveryMethod === DeliveryPreference.PICKUP) {
            deliveryMethod = DelivaryOptionType.Pickup;
        }
        if (deliveryMethod === DeliveryPreference.DROPSHIP) {
            deliveryMethod = DelivaryOptionType.Dropship;
        }
        return deliveryMethod;
    };
    Object.defineProperty(OrderReportsComponent.prototype, "currenyFormatValue", {
        /**
         * To Get Currency Value for the price
         */
        get: function () {
            var _this = this;
            return function (value) {
                if (_this.storeInfo) {
                    value = _this._currencyPipe.getCurrencyFormat(_this.storeInfo, _this.storeInfo.currencyFormatCode, value);
                    return value;
                }
                return value;
            };
        },
        enumerable: true,
        configurable: true
    });
    /**
     * CSV file download functionality
     */
    OrderReportsComponent.prototype.downloadCSV = function (columns, allOrdersReportLength) {
        var rowdata = new Array();
        var finalrows = new Array();
        for (var i = 0; i < allOrdersReportLength; i++) {
            rowdata = [];
            var row = this.allOrdersReport[i];
            rowdata.push(row.itemNumbers ? (String.fromCharCode(39) + row.itemNumbers) : '');
            rowdata.push(row.revisionNumbers ? (String.fromCharCode(39) + row.revisionNumbers) : '');
            rowdata.push(row.webOrderId ? row.webOrderId : '');
            rowdata.push(row.orderNumber ? (String.fromCharCode(39) + row.orderNumber) : '');
            rowdata.push(row.paymentMode ? row.paymentMode : '');
            rowdata.push(row.paymentStatus ? row.paymentStatus : '');
            rowdata.push(row.cardType ? row.cardType : '');
            rowdata.push(row.memberLevelId ? this.getMemberLevel(row.memberLevelId) : '');
            rowdata.push(row.orderTypeId ? this.getOrderType(row.orderTypeId) : '');
            rowdata.push(row.orderCreatedDate ? (String.fromCharCode(39) + this._datePipe.transform(row.orderCreatedDate, DateConstants.DTFormat)) : '');
            rowdata.push(row.orderPostedDate ? (String.fromCharCode(39) + this._datePipe.transform(row.orderPostedDate, DateConstants.DTFormat)) : '');
            rowdata.push(row.paymentDate ? (String.fromCharCode(39) + this._datePipe.transform(row.paymentDate, DateConstants.DTFormat)) : '');
            var distributorId = row.distributorId ? this.distributorFormatPipe.transform(row.distributorId) : '';
            rowdata.push(distributorId);
            rowdata.push(row.memberTypeId ? this.getMemberType(row.memberTypeId) : '');
            rowdata.push(row.orderStatus ? row.orderStatus : '');
            rowdata.push(row.as400Ack ? row.as400Ack : '');
            rowdata.push(row.as400Error ? row.as400Error : '');
            rowdata.push(row.fulfillmentStatus ? row.fulfillmentStatus : '');
            rowdata.push(row.fulfillmentNumber ? (String.fromCharCode(39) + row.fulfillmentNumber) : '');
            rowdata.push(row.fdError ? row.fdError : '');
            rowdata.push(row.orderTotal ? this.currenyFormatValue(row.orderTotal) : '');
            rowdata.push(row.source ? row.source : '');
            rowdata.push(row.shippingMethodDisplayName ? row.shippingMethodDisplayName : '');
            rowdata.push(row.paymentAmount ? this.currenyFormatValue(row.paymentAmount) : '');
            rowdata.push(row.orderCC ? (String.fromCharCode(39) + row.orderCC) : '');
            rowdata.push(row.deliveryMethodId ? this.getDeliveryPreference(row.deliveryMethodId) : '');
            rowdata.push(row.warehouseName ? row.warehouseName : '');
            rowdata.push(row.paymentError ? row.paymentError : '');
            rowdata.push(row.paymentProcessorTransactionNo ? (String.fromCharCode(39) + row.paymentProcessorTransactionNo) : '');
            finalrows.push(rowdata);
        }
        this._customerservice.ExcelDownload(columns, finalrows, 'Orders Report', '', false);
    };
    /**
     * Print functionality for report details printing
     */
    OrderReportsComponent.prototype.printReportDetails = function (title, columns, allOrdersReportLength) {
        var rowdataForPrint = new Array();
        var finalrowsForPrint = new Array();
        for (var i = 0; i < allOrdersReportLength; i++) {
            rowdataForPrint = [];
            var rowForPrint = this.allOrdersReport[i];
            rowdataForPrint.push(rowForPrint.itemNumbers ? rowForPrint.itemNumbers : '');
            rowdataForPrint.push(rowForPrint.revisionNumbers ? rowForPrint.revisionNumbers : '');
            rowdataForPrint.push(rowForPrint.webOrderId ? rowForPrint.webOrderId : '');
            rowdataForPrint.push(rowForPrint.orderNumber ? rowForPrint.orderNumber : '');
            rowdataForPrint.push(rowForPrint.paymentMode ? rowForPrint.paymentMode : '');
            rowdataForPrint.push(rowForPrint.paymentStatus ? rowForPrint.paymentStatus : '');
            rowdataForPrint.push(rowForPrint.cardType ? rowForPrint.cardType : '');
            rowdataForPrint.push(rowForPrint.memberLevelId ? this.getMemberLevel(rowForPrint.memberLevelId) : '');
            rowdataForPrint.push(rowForPrint.orderTypeId ? this.getOrderType(rowForPrint.orderTypeId) : '');
            rowdataForPrint.push(rowForPrint.orderCreatedDate ? this._datePipe.transform(rowForPrint.orderCreatedDate, DateConstants.DTFormat) : '');
            rowdataForPrint.push(rowForPrint.orderPostedDate ? this._datePipe.transform(rowForPrint.orderPostedDate, DateConstants.DTFormat) : '');
            rowdataForPrint.push(rowForPrint.paymentDate ? this._datePipe.transform(rowForPrint.paymentDate, DateConstants.DTFormat) : '');
            var fboId = rowForPrint.distributorId ? this.distributorFormatPipe.transform(rowForPrint.distributorId) : '';
            rowdataForPrint.push(fboId);
            rowdataForPrint.push(rowForPrint.memberTypeId ? this.getMemberType(rowForPrint.memberTypeId) : '');
            rowdataForPrint.push(rowForPrint.orderStatus ? rowForPrint.orderStatus : '');
            rowdataForPrint.push(rowForPrint.as400Ack ? rowForPrint.as400Ack : '');
            rowdataForPrint.push(rowForPrint.as400Error ? rowForPrint.as400Error : '');
            rowdataForPrint.push(rowForPrint.fulfillmentStatus ? rowForPrint.fulfillmentStatus : '');
            rowdataForPrint.push(rowForPrint.fulfillmentNumber ? rowForPrint.fulfillmentNumber : '');
            rowdataForPrint.push(rowForPrint.fdError ? rowForPrint.fdError : '');
            rowdataForPrint.push(rowForPrint.orderTotal ? this.currenyFormatValue(rowForPrint.orderTotal) : '');
            rowdataForPrint.push(rowForPrint.source ? rowForPrint.source : '');
            rowdataForPrint.push(rowForPrint.shippingMethodDisplayName ? rowForPrint.shippingMethodDisplayName : '');
            rowdataForPrint.push(rowForPrint.paymentAmount ? this.currenyFormatValue(rowForPrint.paymentAmount) : '');
            rowdataForPrint.push(rowForPrint.orderCC ? rowForPrint.orderCC : '');
            rowdataForPrint.push(rowForPrint.deliveryMethodId ? this.getDeliveryPreference(rowForPrint.deliveryMethodId) : '');
            rowdataForPrint.push(rowForPrint.warehouseName ? rowForPrint.warehouseName : '');
            rowdataForPrint.push(rowForPrint.paymentError ? rowForPrint.paymentError : '');
            rowdataForPrint.push(rowForPrint.paymentProcessorTransactionNo ? rowForPrint.paymentProcessorTransactionNo : '');
            finalrowsForPrint.push(rowdataForPrint);
        }
        this._customerservice.constructTableAndPrint(columns, finalrowsForPrint, title);
    };
    return OrderReportsComponent;
}());
export { OrderReportsComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/reports/order-reports.component.ts.pre-build-optimizer.js